import { AppLogo, HorizontalNavigation } from '@hawkins/components';
import FeatureFlagToggle from '../FeatureFlagToggle';
import styles from './Header.module.css';
import HelpMenu from '../HelpMenu';

interface HeaderProps {
  name: string;
}

export const Header = ({ name }: HeaderProps) => {
  return (
    <HorizontalNavigation
      className={styles.headerBar}
      logo={<AppLogo href="/" name={name} studioLogo />}
    >
      <div className={styles.rightAlignedHeaderItems}>
        <HelpMenu />
        <FeatureFlagToggle />
      </div>
    </HorizontalNavigation>
  );
};
